<template>
  <div class="item-wrapper">
    <div class="preview">
      <transition name="fade">
        <span class="title" v-if="addToCartChosenItem == item.id">{{
          $t("Added")
        }}</span>
      </transition>
      <img :src="imgDomain + item.image_url" class="img" />
    </div>

    <div class="desc small name">
      <b>{{ item.title }}</b>
    </div>
    <div class="left">
      <div class="price desc small">
        <b>
          <span>
            {{ item.price }}
            <span class="currency text-blue">{{ currency }}</span>
          </span>
        </b>
      </div>
    </div>
    <button
      class="button small bordered"
      @click="$emit('addToCart', item, item.id)"
    >
      BUY
    </button>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: ["item", "currency", "addToCartChosenItem"],
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {},
};
</script>
